export const unitColorChannelToByte = (value: unknown): number =>
  Math.max(0, Math.min(255, Math.round(Number(value || 0) * 255)));

export const unitRgbToHex = (color: unknown, fallback: number[] = [0, 0, 0]): string => {
  const safe = Array.isArray(color) ? color : fallback;
  const [r, g, b] = safe;
  return `#${[r, g, b]
    .map((value) => unitColorChannelToByte(value).toString(16).padStart(2, "0"))
    .join("")}`;
};

export const hexToUnitRgba = (
  hex: unknown,
  alpha = 1,
  fallback: number[] = [0, 0, 0, alpha]
): number[] => {
  if (typeof hex !== "string" || !/^#[0-9a-fA-F]{6}$/.test(hex)) return fallback;
  return [
    Number.parseInt(hex.slice(1, 3), 16) / 255,
    Number.parseInt(hex.slice(3, 5), 16) / 255,
    Number.parseInt(hex.slice(5, 7), 16) / 255,
    alpha,
  ];
};
